var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGuide = function SvgGuide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5 6.75A2.75 2.75 0 0 1 7.75 4h8a2.75 2.75 0 0 1 2.75 2.75v8.917h.003v1.5c-.145 0-.223.05-.277.116-.067.082-.134.236-.134.467 0 .322.261.583.583.583v1.5H7.083A2.083 2.083 0 0 1 5 17.75zm12 0v8.917H7.083q-.304 0-.583.082V6.75c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25m-10.5 11c0-.322.261-.583.583-.583h9.577q-.069.287-.068.583.001.304.083.583H7.083a.583.583 0 0 1-.583-.583M9.747 7.583a.833.833 0 0 0 0 1.667h4a.833.833 0 0 0 0-1.667z",
    clipRule: "evenodd"
  })));
};
export default SvgGuide;